module.exports = __webpack_public_path__ + "img/product3-2.bcf86882.jpg";